<template>
<div id="ProductModelCol" class="product-model-col">
  <div class="image" @click.stop="handleClickImage">
    <el-image :src="$staticHost(row.imageUrl)" fit="contain">
      <div slot="error" class="image-slot" style="height: 48px;">
        <img :src="productDefaultThumb" height="48" width="48" alt="" />
      </div>
    </el-image>
  </div>
  <div class="text">
    <div class="">
      <span class="line1" @click.stop="handleClickModel">{{ row.model }}</span>
    </div>
    <div class="text-line flex-align-center">
      <div class="line2 mg-rt-md">产品系列：{{ row.productSeriesName || row.seriesName }}</div>
      <div v-if="row.sampleId" class="link-text flex-align-center" @click.stop="toViewPdf">
        <img src="~@/assets/image/pdf_icon.png" class="mg-rt-sm" width="16" />
        <span class="link-text">查看样册</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import productDefaultThumb from '@/assets/image/product_default_thumb.png'
import { mapGetters } from 'vuex'
import openUrlMixin from '@/mixins/openUrlMixin'
export default {
  name: 'ProductModelCol',
  mixins: [openUrlMixin],
  props: {
    row: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      productDefaultThumb,
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
    }),
  },
  methods: {
    handleClickImage() {
      this.$emit('image-click', this.row)
    },
    handleClickModel() {
      this.$emit('model-click', this.row)
    },
    async toViewPdf() {
      if (!this.row.sampleId && this.row.sampleId !== 0) { return }
      try {
        this.$fullLoading.open()
        const url = await this.$api.documents.sampleUrl(this.row.sampleId)
        await this.openUrl(url)
      } catch (err) {
        this.$message.error('获取样册链接失败')
      } finally {
        this.$fullLoading.close()
      }
    },
  }
}
</script>

<style lang="less" scoped>
.product-model-col{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.image{
  flex: 0 0 50px;
  width: 48px;
  height: 48px;
  margin: 0 4px 2px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  &:hover{
    box-shadow: 2px 2px 4px 0 rgba(60,130,180,.5);
  }
}
.text{
  flex: 1;
  .text-line{
    //flex-wrap: nowrap;
  }
  .line1{
    color: @theme-color;
    font-weight: 500;
    cursor: pointer;
    &:hover{
      color: @theme-hover-color;
    }
  }
  .line2{
    flex-wrap: nowrap;
    color: @theme-text-main;
    line-height: 22px;
  }
  .link-text{
    line-height: 22px;
    color: @theme-color;
    flex: 0 0 50px;
  }
}
</style>
